import { Container, Button,Form, Alert,Table} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import React from 'react';
import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend';

class MyComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
          data: null,
          isLoading: false,
          error: null,
          resultVariant :"success",
          resultVisible:false,
          resultText :'N/A',
          spinnerHidden:false,
          subscriptions:null
        }
    }

    CheckAccessToken;

    componentDidMount() {
        this.getData();
    }

    getData = () =>{
        fetch('/backend/mysubscriptions', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'accessToken':localStorage.getItem('access_token'),
        },
        }).then(response => response.json())
        .then(data => {
            if (data.errorsException===false) {
                this.setState({ resultVariant :'success', resultVisible:false, resultText: data.resultText, spinnerHidden:true, subscriptions:data.mySubscriptions  });
            } else {
                console.log("2");
                this.setState({ resultVariant :'warning', resultVisible:true, resultText: data.resultText, spinnerHidden:true  });
            }
        })
        .catch(error => {
            this.setState({ resultVariant :'warning', resultVisible:true, resultText: 'Ett fel uppstod!', spinnerHidden:true  });
            //this.setState({   });
        });
    }    

    render() {
        if (this.state.subscriptions !== null) {
            return (
                <ContentWrapper>
                    <Container>
                        <Sida>
                        <Rubrik>Mina Tjänster</Rubrik>
                            <Table  responsive="sm">
                                <thead>
                                    <tr><td><small>Produkt</small></td> <td><small></small></td> <td><small><small>Pris/månad</small></small></td>  <td><small><small>Bindningstid</small></small></td>  <td><small>Status</small></td> </tr>
                                </thead>
                                <tbody>
                                    {this.state.subscriptions.map((item) => {
                                        return <tr key={item.productName}><td><small>{item.productName}</small></td> <td><small>{item.subscriptionComment}</small></td> <td><small>{item.productPrice}:-</small></td> <td><small>{item.subscriptionBindDate}</small></td> <td><small>{item.subscriptionState}</small></td></tr>
                                    })}
                                </tbody>
                            </Table>
                            <small><small>Priser angiva exklusive moms.</small></small>

                        <Form onSubmit={this.handleSubmit}>

                            <Form.Group className="mb-3"  hidden={this.state.spinnerHidden}>
                                <SpinnerX  />
                            </Form.Group>                                      
                                
                            <Form.Group className="mb-3"  hidden={!this.state.resultVisible}>
                                <Alert show={this.state.resultVisible} variant={this.state.resultVariant}  className="FormSpace">{this.state.resultText}</Alert> 
                            </Form.Group>         
                        </Form>                 
                    </Sida>
                    </Container>
                </ContentWrapper>
            );
        } else {
            return (
                <ContentWrapper>
                    <Container>
                        <Sida>
                        <Rubrik>Laddar tjänster</Rubrik>
                        <SpinnerX  />
                    </Sida>
                    </Container>
                </ContentWrapper>
            );        
        }
    }
}

export default MyComponent;